import { Box, ListItemButton, ListItemText } from "@mui/material";
import { Link } from "react-router";
import type { AssistantTask } from "../../../../api/types/assistantTypes";
import { getScheduledTaskLine, getTaskOutcomeLine } from "./taskStatus";
import TaskStatusChip from "./TaskStatusChip";

export type TaskListKind = "outcome" | "scheduled";

interface Props {
  task: AssistantTask;
  kind: TaskListKind;
  to: string;
  divider: boolean;
}

const TaskListRow = ({ task, kind, to, divider }: Props) => (
  <ListItemButton component={Link} to={to} divider={divider} sx={{ gap: 1 }}>
    <ListItemText
      primary={task.name}
      secondary={kind === "scheduled" ? getScheduledTaskLine(task) : getTaskOutcomeLine(task)}
    />
    <Box sx={{ flexShrink: 0 }}>
      <TaskStatusChip task={task} kind={kind === "scheduled" ? "state" : "outcome"} height="smaller" />
    </Box>
  </ListItemButton>
);

export default TaskListRow;
